export default __webpack_public_path__ + "static/media/profilebluedashborad.484f3f35.svg";